import { HttpClient, HttpHeaders } from "@angular/common/http";
import {Injectable} from '@angular/core';
import { IPaginatedResponse, IService } from "maps-angular-components";
import {Observable} from "rxjs";
import { CarteiraAutocompleteModel } from "./carteira.model";
import { catchError } from "rxjs/operators";
import {handleError} from "../shared/util/error-util";

@Injectable({
    providedIn: 'root'
})
export class CarteiraGrupoAutocompleteService implements IService<CarteiraAutocompleteModel> {

    url: string = "/v1/carteiras-grupos";

    constructor(private http: HttpClient) {
    }

    parsePaginatedResponse(response): IPaginatedResponse<CarteiraAutocompleteModel> {
        return {
            total: null,
            data: response.map(item => new CarteiraAutocompleteModel(item))
        };
    };

    autocomplete(identificador: string, endpoint: string = ''): Observable<CarteiraAutocompleteModel> {
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const options = {headers};
        return this.http.get<any>(`${this.url}?search=${encodeURIComponent(identificador)}`, options).pipe(catchError(handleError));
    }

}
